import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { IBenchConsultant } from "../../models/BenchConsultant";
import { History } from "./History";
import { Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { IBenchInterview, Interview } from "./Interview";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { ILogin } from "../../models/Login";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    singleData: IBenchConsultant,
    open: boolean,
    hideDialog: () => void,
    toast: any,
}

export const BenchECIList = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBenchInterview>, loading: boolean });

    useEffect(() => {
        if (props.singleData.consultant_ID) loadTableData();
    }, [props.singleData.consultant_ID]);

    const [interviewForm, setInterviewForm] = useState({ singleData: {}, open: false } as { singleData: IBenchInterview, open: boolean });
    const hideInterviewFormDialog = () => { setInterviewForm({ singleData: {}, open: false }) };
    const [history, setHistory] = useState({ submission_ID: 0, consultant_Name: '', open: false } as { submission_ID: number, consultant_Name: string | undefined, open: boolean });
    const hideHistory = () => {
        setHistory({ submission_ID: 0, consultant_Name: '', open: false });
    }

    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Consultant_Bench/eciList", "GET", null, `consultant_ID=${props.singleData.consultant_ID}`, props.toast);
        if (response) {
            const data: Array<IBenchInterview> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const interview_Date = (rowData: IBenchInterview) => {
        let date;
        if (rowData.interview_Date) date = format(new Date(rowData.interview_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const interview_Time = (rowData: IBenchInterview) => {
        return (<>{rowData.interview_Time} {rowData.time_Zone_Name}</>);
    };
    const interview_Status = (rowData: IBenchInterview) => {
        return ((rowData.interview_Status !== "Backout" && rowData.interview_Status !== "Confirmed" && rowData.interview_Status !== "ECI Canceled" && rowData.interview_Status !== "Rejected") || (_role.includes(1)) ?
            <span className="cursor-pointer text-cyan-700 underline"
                onClick={() => setInterviewForm({ singleData: rowData, open: true })}>{rowData.interview_Status}</span>
            : <span>{rowData.interview_Status}</span>);
    };
    const bLifeCycle = (rowData: IBenchInterview) => {
        return (
            <Button onClick={() => { if (rowData.submission_ID) setHistory({ submission_ID: rowData.submission_ID, consultant_Name: rowData.consultant_Name, open: true }) }} icon="pi pi-history" className="p-button-rounded p-button-secondary p-button-text" aria-label="History" />
        );
    };

    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    }

    const DateFormat = loginObj.date_Format;

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Bench ECI List" modal className="p-fluid" onHide={onHide}>
            <DataTable className="field col-12 md:col-12" style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" value={tableData.tableData} loading={tableData.loading} showGridlines
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                {/* <Column field="interview_Date" header="Interview Date" body={interview_Date} /> */}
                <Column field="interview_Date" header="Interview Date" body={(rowData: any) => safeFormatDate(rowData.interview_Date, 'dd/MM/yyyy', DateFormat)} />
                <Column field="interview_Time" header="Interview Time" body={interview_Time} />
                <Column field="sales_Manager" header="Sales Manager" />
                <Column field="consultant_Name" header="Consultant" />
                <Column field="client" header="Prime Vendor" />
                <Column field="endClient" header="Client" />
                <Column field="location" header="Location" />
                <Column field="interview_Status" header="Interview Status" body={interview_Status} />
                <Column field="interview_Comments" header="Comments" />
                <Column field="lifeCycle" header="LifeCycle" body={bLifeCycle} />
            </DataTable>
            <Interview onHide={onHide} singleData={interviewForm.singleData} open={interviewForm.open} hideDialog={hideInterviewFormDialog} toast={props.toast} />
            <History open={history.open} submission_ID={history.submission_ID} consultant_Name={history.consultant_Name} toast={props.toast} hideDialog={hideHistory} />
        </Dialog>
    );
}
